import React, { FC } from 'react';

interface DynamicHtmlProps extends React.HTMLAttributes<HTMLOrSVGElement> {
    tagName?: keyof JSX.IntrinsicElements;
    content: string;
}

const DynamicHtml: FC<DynamicHtmlProps> = ({ tagName, content }: DynamicHtmlProps) => {
    const Tag = tagName as keyof JSX.IntrinsicElements;
    return <Tag dangerouslySetInnerHTML={{ __html: content }} />;
}

DynamicHtml.defaultProps = {
    tagName: 'div',
};

export default DynamicHtml